export enum MarketShowStatus {
    active = '0',
    finished = '1',
    cancelled = '2',
    expired = '3',
}